import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import styles from './KnowledgeErrorPlaceholder.module.scss';
export function KnowledgeErrorPlaceholder({ message, }) {
    return (_jsx(Text.Paragraph, Object.assign({ className: styles.message, variant: "4", subdued: true }, { children: message ||
            'Something went wrong, please reload and try again. If this issue persists, please contact support.' })));
}
